module.exports = __webpack_public_path__ + "static/bayarea-7b8b735c8c7868a9ad486aba2a3998ee.jpg";